import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../../components/pdf/Preview'

const PageContent = ({ templateId }) => {
  return (
    <PdfOptionsFormHandler initialState={{ fontBaseColor: '#333' }}>
      <Grid align="stretch">
        <Col flex={3} flex_mdd={0} scroll height="calc(100vh - 4.8rem)">
          <Preview>
            <PdfDocument templateId={templateId} />
          </Preview>
        </Col>
      </Grid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
